import React, { useState } from "react";
import { PlusIcon } from "@heroicons/react/solid";
import { useNavigate } from "react-router-dom";
import useRead from "../../hooks/useRead";
import usePut from "../../hooks/usePut";
import toast from "react-hot-toast";
import InlineLoader from "../../components/loader/InlineLoader";
import { Button } from "../../components/ui";
import RoundedContainer from "../../components/containers/RoundedContainer";

const Employment = () => {
  const navigate = useNavigate();
  const [isOpenAdvanceEmployment, setIsOpenAdvanceEmployment] = useState(false);
  const [isOpenCreateAdvanceEmployment, setIsOpenCreateAdvanceEmployment] =
    useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [name, setName] = useState("");
  const [type_of_employee, setType_of_employee] = useState("");

  const handleClickedAdvanceShift = (id) => {
    setIsOpenAdvanceEmployment(true);
    let data = employmentList.data?.data.find((x) => x.id === id);
    setSelectedId(data.id);
    setName(data.name);
    setType_of_employee(data.type_of_employee);
  };

  const create = usePut({
    url: "employment_create_and_update",
    refreshUrl: [
      "employment_listing",
      "dashboard/company_completion_status",
      "is_permission_for_product",
    ],
    onSuccess: (res) => {
      toast.success(
        res?.data?.message ||
          (selectedId
            ? "Employment Updated Successfully"
            : "Employment Added Successfully")
      );
      setIsOpenAdvanceEmployment(false);
      setIsOpenCreateAdvanceEmployment(false);
      setSelectedId(null);
      setName("");
      if (sessionStorage.getItem("onboarding_flow") === "true") {
        sessionStorage.removeItem("onboarding_flow");
        // navigate("/onboarding");
      }
    },
  });

  const { list: employmentList } = useRead({
    url: "employment_listing",
    initialData: {
      limit: 50,
      search_query: "",
    },
  });

  const handleCreateOrUpdateForm = (e) => {
    e.preventDefault();
    let data = {
      name,
      type_of_employee,
      id: selectedId || "",
    };
    create.handleAuth.mutate(data);
  };

  const handleCloseModal = () => {
    setIsOpenAdvanceEmployment(false);
    setIsOpenCreateAdvanceEmployment(false);
    setSelectedId(null);
    setName("");
  };

  return (
    <>
      <div className="p-5">
        <div className="flex justify-between items-center mb-5">
          <h1 className="text-2xl font-bold text-primary">Employment Types</h1>
          <Button
            onClick={() => setIsOpenCreateAdvanceEmployment(true)}
            variant="default"
            className="flex items-center space-x-2"
          >
            <PlusIcon className="w-5 h-5" />
            <span className="font-semibold">Add Employment</span>
          </Button>
        </div>
        {!employmentList.data?.data?.length ? (
          <RoundedContainer className="text-center py-16">
            <p className="text-gray-700 text-2xl font-semibold mb-2">
              No Employment Types To Show
            </p>
            <p className="text-gray-500 text-sm mb-5">
              Add employment types like Full-Time, Part-Time, Intern, etc.
            </p>
            <Button
              onClick={() => setIsOpenCreateAdvanceEmployment(true)}
              variant="default"
              className="inline-flex items-center space-x-2"
            >
              <PlusIcon className="w-5 h-5" />
              <span className="font-semibold">Add Employment</span>
            </Button>
          </RoundedContainer>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {employmentList.data?.data.map((item) => {
              const { name, id } = item;
              return (
                <RoundedContainer
                  key={id}
                  className="flex flex-col justify-between p-5 border border-gray-100 hover:shadow-md transition-shadow"
                >
                  <div>
                    <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">
                      Employee Type
                    </p>
                    <p className="text-lg font-bold text-primary">{name}</p>
                  </div>
                  <div className="mt-5 pt-3 border-t border-gray-100 flex justify-end">
                    <Button
                      onClick={() => handleClickedAdvanceShift(id)}
                      variant="outline"
                      size="sm"
                    >
                      Edit Employment
                    </Button>
                  </div>
                </RoundedContainer>
              );
            })}
          </div>
        )}
      </div>

      {isOpenAdvanceEmployment && (
        <div className="fixed inset-0 z-[1002] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-6 mx-4">
            <div className="pb-3 border-b border-gray-200">
              <h2 className="font-semibold text-xl text-primary">
                Edit Employment
              </h2>
            </div>
            <form
              className="pt-4 space-y-4"
              onSubmit={handleCreateOrUpdateForm}
            >
              <div>
                <label className="label text-sm font-medium text-gray-700 mb-1 block">
                  Employment Name
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  name="title"
                  required={true}
                  className="input"
                  placeholder="Enter Employment name"
                />
              </div>
              {/* <div className=''>
                <label className='label text-base'>Employee Type: </label>
                <select name="" className='input' required={true} value={type_of_employee} onChange={(e) => setType_of_employee(e.target.value)}>
                  <option value="">--Select Employee Type--</option>
                  <option value="employee">Employee</option>
                  <option value="consultant">Consultant</option>
                </select>
              </div> */}
              <div className="flex justify-end space-x-3 pt-3">
                <Button
                  onClick={handleCloseModal}
                  type="button"
                  variant="outline"
                >
                  Close
                </Button>
                <Button
                  variant="default"
                  type="submit"
                  disabled={create.handleAuth.isLoading}
                  className="flex items-center space-x-2"
                >
                  <span>Update Employment</span>
                  {create.handleAuth.isLoading && <InlineLoader />}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {isOpenCreateAdvanceEmployment && (
        <div className="fixed inset-0 z-[1002] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="w-full max-w-md bg-white rounded-lg shadow-xl p-6 mx-4">
            <div className="pb-3 border-b border-gray-200">
              <h2 className="font-semibold text-xl text-primary">
                Create Employment
              </h2>
            </div>
            <form
              className="pt-4 space-y-4"
              onSubmit={handleCreateOrUpdateForm}
            >
              <div>
                <label className="label text-sm font-medium text-gray-700 mb-1 block">
                  Employment Name
                </label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  name="title"
                  required={true}
                  className="input"
                  placeholder="Enter Employment name"
                />
              </div>
              {/* <div className=''>
                <label className='label text-base'>Employee Type: </label>
                <select name="" className='input' required={true} value={type_of_employee} onChange={(e) => setType_of_employee(e.target.value)}>
                  <option value="">--Select Employee Type--</option>
                  <option value="employee">Employee</option>
                  <option value="consultant">Consultant</option>
                </select>
              </div> */}
              <div className="flex justify-end space-x-3 pt-3">
                <Button
                  onClick={handleCloseModal}
                  type="button"
                  variant="outline"
                >
                  Close
                </Button>
                <Button
                  variant="default"
                  type="submit"
                  disabled={create.handleAuth.isLoading}
                  className="flex items-center space-x-2"
                >
                  <span>Save Employment</span>
                  {create.handleAuth.isLoading && <InlineLoader />}
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Employment;
